module.exports = __webpack_public_path__ + "img/car_shina2_30.9a15c55e.jpg";